import React from 'react';
import './index.scss';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import { ReactComponent as Boi } from '../../assets/Images/boi.svg';
import { ReactComponent as Ave } from '../../assets/Images/ave.svg';
import { ReactComponent as Porco } from '../../assets/Images/porco.svg';
import { ReactComponent as Cordeiro } from '../../assets/Images/cordeiro.svg';
import { ReactComponent as Espeto } from '../../assets/Images/espetos.svg';
import { ReactComponent as Acomp } from '../../assets/Images/acompanhamentos.svg';
import { ReactComponent as Sobremesa } from '../../assets/Images/sobremesa.svg';


class NoMatchPage extends React.Component<{}> {

  render () {
    return (
      <>
        <Header/>
        
        <section className="no-match-page">
          <div className="overlay-404"/>
          <h1 className="title-404"> A página que você está procurando não existe </h1>
          <p className="aproveite"> Aproveite a viagem para confirerir nossos Assados! </p>

          <div className="assados">
            <a href="/" className="item-404">
              <div>
                <Boi className="icon-bull"/>
              </div>
              <p> Carnes de Boi </p>
            </a>
            <a href="/" className="item-404">
              <div>
                <Porco className="icon-pig"/>
              </div>
              <p> Carnes de Porco </p>
            </a>
            <a href="/" className="item-404">
              <div>
                <Ave className="icon-bird"/>
              </div>
              <p> Carnes de Ave </p>
            </a>
            <a href="/" className="item-404">
              <div>
                <Cordeiro className="icon-sheep"/>
              </div>
              <p> Carnes de Cordeiro </p>
            </a>
            <a href="/" className="item-404">
              <div>
                <Espeto/>
              </div>
              <p> Espetos </p>
            </a>
            <a href="/" className="item-404">
              <div>
                <Acomp className="icon-bowl"/>
              </div>
              <p> Acompanhamentos </p>
            </a>
            <a href="/" className="item-404">
              <div>
                <Sobremesa href="/" className="icon-dessert"/>
              </div>
              <p> Sobremesas </p>
            </a>
          </div>
          <a href="/" className="btn-primary-action back-home"> Voltar para a Home </a>
        </section>

        <Footer/>
      </>
    );
  }
}

export default NoMatchPage;